var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-1491 -226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(1495.208 234.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-0.208 -0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M.942,1.5h21.7c1.269,0,1.269-1.5,0-1.5H.942C-.314,0-.314,1.5.942,1.5Z",
    transform: "translate(0.208 0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81_-_Outline",
    "data-name": "Path 81 - Outline",
    d: "M22.586,1.7H1C.211,1.7-.2,1.222-.2.75S.211-.2,1-.2H22.586c.792,0,1.207.478,1.207.95S23.378,1.7,22.586,1.7ZM1,.2C.463.2.321.546.321.75S.463,1.3,1,1.3H22.586c.474,0,.686-.276.686-.55S23.06.2,22.586.2Z",
    transform: "translate(0.208 0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M.944,7.04h21.7c1.269,0,1.269-1.5,0-1.5H.944c-1.269,0-1.269,1.5,0,1.5Z",
    transform: "translate(0.208 2.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82_-_Outline",
    "data-name": "Path 82 - Outline",
    d: "M22.586,7.24H1c-.792,0-1.207-.478-1.207-.95S.207,5.34,1,5.34H22.586c.792,0,1.207.478,1.207.95S23.378,7.24,22.586,7.24ZM1,5.74c-.474,0-.686.276-.686.55s.212.55.686.55H22.586c.474,0,.686-.276.686-.55s-.212-.55-.686-.55Z",
    transform: "translate(0.208 2.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M.944,12.1h21.7c1.269,0,1.269-1.5,0-1.5H.944c-1.269,0-1.269,1.5,0,1.5Z",
    transform: "translate(0.208 3.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83_-_Outline",
    "data-name": "Path 83 - Outline",
    d: "M22.586,12.3H1c-.792,0-1.207-.478-1.207-.95S.207,10.4,1,10.4H22.586c.792,0,1.207.478,1.207.95S23.378,12.3,22.586,12.3ZM1,10.8c-.474,0-.686.276-.686.55s.212.55.686.55H22.586c.474,0,.686-.276.686-.55s-.212-.55-.686-.55Z",
    transform: "translate(0.208 3.965)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.9c0896e1890f606d05081374fda0ce20.svg";
export { ForwardRef as ReactComponent };